(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .factory('FileFactory', FileFactory);

    FileFactory.$inject = ['$resource'];

    /* @ngInject */
    function FileFactory($resource) {
        return $resource('api/file/:id',
            {id: "@id"},
            {
                upload: {
                    method:'POST',
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined, enctype:'multipart/form-data' }
                }
            }
        );
    }

})();

